import { useEffect } from 'react';
import noop, { NoOp } from 'utils/noop';
import { BasicFilterSelect, BaseOption, SelectionDetails } from 'ui/selects';
import ResourceTooltipWrapper from './ResourceTooltipWrapper';
import { InternalOnChangeProp, ResourceFieldProps } from './ResourceSelect.types';

interface ResourceSelectProps extends ResourceFieldProps {
  /** Are the options currently loading? */
  isLoading?: boolean;
  /** Options for the dropdown */
  options?: BaseOption[];
  /** tooltip text shown when no resource options are available */
  noResourceHelpText?: string;
  onChange: (e: InternalOnChangeProp) => void | NoOp;
  isDisabled?: boolean;
  /** setting tooltip content if disabled */
  setTooltipContent?: (content: string) => void;
}

/**
 * Returns a select field configured for resources
 */
export const ResourceSelect = ({
  isLoading = false,
  noResourceHelpText = '',
  options = [],
  value,
  isDisabled = false,
  onChange = noop,
  setTooltipContent = noop,
  ...props
}: ResourceSelectProps) => {
  useEffect(() => {
    if (value && options.length) {
      const selected = options.find((o) => o.value === value);
      setTooltipContent((selected?.label ?? '') as string);
    }
  }, [value, options]);

  return (
    <ResourceTooltipWrapper
      hasTooltip={!options.length}
      tooltipText={isLoading ? 'Loading...' : noResourceHelpText}
    >
      <BasicFilterSelect
        {...props}
        isDisabled={isDisabled}
        data-formfieldtype="select"
        options={options.sort((a, b) => (a.label as string).localeCompare(b.label as string))}
        onSelect={(valArr: string[], { selectedOptions = [] }: SelectionDetails) =>
          onChange(selectedOptions[0] as InternalOnChangeProp)
        }
        defaultValues={value ? [value] : []}
        isFullWidth
      />
    </ResourceTooltipWrapper>
  );
};

export default ResourceSelect;
